import { put } from 'redux-saga/effects';
import EasyRedux from '../../../utils/EasyRedux';
import handleSagaError from '../../handleSagaError';
import { history } from '../../../utils';

const key = 'USERSITE/GET';

export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchGetUserSite(client, { payload: { resolve, reject } }) {
  try {
    const { result } = yield client.post('/site/get');
    yield put(actions.loadSuccess(result));
    resolve && resolve(result);
  } catch (e) {
    reject && reject(e);
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
  }
}

export default reducer;
